module.exports = __webpack_public_path__ + "a670c9f18e0a769533f6fa71863219d4.pdf";